export default {
  title: 'Espaces',
  subtitle: "Tous les espaces de l'organisation, y compris ceux dont vous n'êtes pas membre.",
  create: 'Nouvel espace',
  stats: {
    all: 'Espaces',
    allHint: "dans l'organisation",
    public: 'Publics',
    publicHint: 'visibles par les membres',
    private: 'Privés',
    privateHint: 'sur invitation',
    pool: 'Fonds commun',
    poolHint: 'médias partagés',
    storage: 'Stockage total',
    storageHint: 'aucun espace inactif | 1 espace inactif | {count} espaces inactifs',
  },
  filters: {
    label: 'Visibilité',
    all: 'Tous',
    public: 'Publics',
    private: 'Privés',
    pool: 'Fonds commun',
    dormant: 'Sans activité depuis 6 mois',
    search: 'Rechercher un espace ou un propriétaire',
  },
  table: {
    name: 'Espace',
    visibility: 'Visibilité',
    members: 'Membres',
    assets: 'Médias',
    storage: 'Stockage',
    duration: 'Durée',
    lastActivity: 'Dernière activité',
    owner: 'Propriétaire : {name}',
    ownerGone: 'Propriétaire : compte supprimé',
    never: 'Jamais',
    empty: 'Aucun espace ne correspond à ces filtres.',
  },
  visibility: {
    public: 'Public',
    private: 'Privé',
    pool: 'Fonds commun',
  },
  actions: {
    label: "Actions sur l'espace",
    open: "Ouvrir l'espace",
    members: 'Gérer les membres',
  },
  footer: '{shown} espace affiché sur {total} · {size} | {shown} espaces affichés sur {total} · {size}',
  storageNote: "Stockage : fichiers originaux, versions encodées et vignettes de chaque média listé dans l'espace.",
}
